import { TFunction } from 'i18next';

export type ServiceCategoryLabelSource = {
  slug: string;
  label: string;
  label_fr?: string | null;
  label_en?: string | null;
};

/** Admin override applies only when both bilingual labels were set explicitly. */
export function hasAdminBilingualLabels(
  category: Pick<ServiceCategoryLabelSource, 'label_fr' | 'label_en'>
): boolean {
  return Boolean(category.label_fr?.trim() && category.label_en?.trim());
}

export function resolveServiceCategoryLabel(
  category: ServiceCategoryLabelSource,
  locale: string,
  t: TFunction
): string {
  const isEn = locale.startsWith('en');

  if (hasAdminBilingualLabels(category)) {
    return isEn ? category.label_en!.trim() : category.label_fr!.trim();
  }

  const i18nKey = `serviceCategories.${category.slug}`;
  const i18nLabel = t(i18nKey, { ns: 'common', defaultValue: category.label.trim() });
  return i18nLabel !== i18nKey ? i18nLabel : category.label.trim();
}
